import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';
import useCurrentGameId from '@/shared/hooks/useCurrentGameId';
import type { SportEvent } from '../types/SportEventTypes';

/**
 * Hook to fetch custom play-by-play events for a game
 *
 * Custom events are already transformed to match SES event format,
 * so they can be merged seamlessly in SportEventContext
 */
interface CustomEventsResponse {
  success: boolean;
  events: SportEvent[];
  count: number;
}

const useCustomEventsQuery = (gameIdParam?: string) => {
  const currentGameId = useCurrentGameId();
  const gameId = gameIdParam || currentGameId;

  return useQuery({
    queryKey: ['Games', gameId, 'CustomEvents'],
    queryFn: async () => {
      // Endpoint returns wrapped response with events array
      const response = await get<CustomEventsResponse>(
        `/v1.0/games/${gameId}/custom-events`
      );
      return response.data.events; // Extract events array from wrapped response
    },
    enabled: !!gameId, // Only fetch when we have a gameId
    staleTime: 30000, // Consider data fresh for 30 seconds
  });
};

export default useCustomEventsQuery;
